import { App, Plugin, watch } from 'vue';
import { defineStore } from 'pinia';

import type { AuthUser, ApplicationItem } from '@lib/types';
import axios from 'axios';

export const useAppApplicationStore = defineStore('appApplication', {
	state: () => {
		return {
			enabled: false,
			applications: Array<ApplicationItem>()
		};
	},
	actions: {
		enable() {
			this.$state.enabled = true;
		},
		set(applications: Array<ApplicationItem>) {
			this.$state.applications = applications;
		}
	}
});

export const AppApplicationPlugin: Plugin = {
	install: (app: App /*options?: ApplicationOptions*/) => {
		// We are not in a vue instance yet, injection based useComposables do not work, pinja stores do
		const auth = app.config.globalProperties.$auth;

		// Watch for the user logged in
		watch(
			() => auth.user(),
			async (user: AuthUser) => {
				if (user) {
					const applicationStore = useAppApplicationStore();
					// Get the available apps for the user
					if (user.applications) {
						applicationStore.set(user.applications);
						// Enable the plugin inside the layout
						applicationStore.enable();
					}
				}
			}
		);
	}
};
